import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { BrowserRouter } from "react-router";
import { createRoot } from "react-dom/client";
import Router from "./routes.tsx";
import "./index.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Toaster } from "./components/ui/toaster.tsx";
import { AdminModeProvider } from "./contexts/AdminModeContext";
import { TooltipProvider } from "./components/ui/tooltip";
import { I18nProvider } from "./contexts/I18nContext";

Sentry.init({
  dsn: "https://4d0836eb28b16b9828bfc99d3efd34cc@o4509204722941952.ingest.de.sentry.io/4509204725956688",
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <AdminModeProvider>
        <I18nProvider>
          <TooltipProvider delayDuration={200}>
            <ToastContainer />
            <Toaster />
            <Router />
          </TooltipProvider>
        </I18nProvider>
      </AdminModeProvider>
    </BrowserRouter>
  </StrictMode>,
);
